import AHDate from "_shared/dates/date";
import EntityMember from "_shared/entity-members/entity-member";
import Guid from "_shared/guids/guid";
import {
  ProposalReviewerJSON,
  ProposalReviewerParams,
} from "work/proposals/reviewers/_schemas/proposal-reviewer-schema";

export default class ProposalReviewer {
  public readonly canEdit: boolean;
  public readonly entityMember: EntityMember;
  public readonly dateApproved?: AHDate;
  public readonly customMessage?: string;

  constructor(params: ProposalReviewerParams) {
    const { canEdit, entityMember: entityMemberParams, dateApproved, customMessage } = params;
    this.canEdit = canEdit;
    this.entityMember = EntityMember.create({
      ...params,
      ...entityMemberParams,
    });
    this.dateApproved = dateApproved;
    this.customMessage = customMessage;
  }

  public get userId(): Guid {
    return this.entityMember.userId;
  }
  public get entityId(): Guid {
    return this.entityMember.legalEntityId;
  }

  public isEqualTo = (other: ProposalReviewer): boolean =>
    this.entityMember.isEqualTo(other.entityMember) &&
    this.canEdit === other.canEdit &&
    (this.customMessage ?? "") === (other.customMessage ?? "");

  public clone(): this {
    return this;
  }

  public toJSON(): ProposalReviewerJSON {
    return {
      userId: this.entityMember.userId.toJSON(),
      legalEntityId: this.entityMember.legalEntityId.toJSON(),
      canEdit: this.canEdit,
      dateApproved: this.dateApproved?.toISOString(),
      customMessage: this.customMessage ?? "",
    };
  }

  public static fromJSON(json: ProposalReviewerJSON): ProposalReviewer {
    const entityMember = EntityMember.fromJSON(json);
    if (!entityMember) {
      throw new Error("Cannot create ProposalReviewer from JSON with invalid EntityMember");
    }
    return new ProposalReviewer({
      entityMember,
      canEdit: json.canEdit,
      dateApproved: json.dateApproved ? new AHDate(json.dateApproved) : undefined,
      customMessage: json.customMessage ?? undefined,
    });
  }
}
